module.exports = __webpack_public_path__ + "img/csv.1e71d809.svg";